<template>
    <div class="row login-page">

        <a href="/" class="logo">
            <img src="/images/logo-planit-easy-full-white.svg" alt="Logo PlanitEasy.nl">
        </a>

        <div class="column medium-8 medium-centered large-6">
            <form class="log-in-form">
                <div class="loading" v-show="loading">
                    <font-awesome-icon :icon="['fas', 'spinner']" spin/>
                </div>

                <div class="text-center" v-if="pitDisabled">
                    <br><br><br>
                    <h3>PlanitEasy is (tijdelijk) niet beschikbaar.</h3>
                    <p><small>Kom later terug!</small></p>
                    <br><br>
                </div>

                <div v-else>
                    <slide-up-down :active="view == 'login'" :duration="500">
                        <div class="login-image">
                            <img src="/images/undraw_deliveries_131a.svg">
                        </div>

                        <h4 class="text-center">Inloggen bij Planit<strong>Easy</strong></h4>

                        <slide-up-down :active="!!timedout" :duration="500">
                            <b-notification type="is-warning">
                                Je bent automatisch uitgelogd wegens inactiviteit.
                            </b-notification>
                        </slide-up-down>

                        <slide-up-down :active="!!loginerror" :duration="500">
                            <b-notification type="is-danger" aria-close-label="Sluiten" role="alert">{{ loginerror != false ? loginerror : '' }}</b-notification>
                        </slide-up-down>

                        <b-field label="E-mailadres">
                            <b-input v-model="loginData.email" type="email" placeholder="mijn@emailadres.nl" @keyup.native.enter="submitLogin"></b-input>
                        </b-field>

                        <b-field label="Wachtwoord">
                            <b-input v-model="loginData.password" type="password" placeholder="******" @keyup.native.enter="submitLogin"></b-input>
                        </b-field>

                        <div class="button-wrap">
                            <b-button type="is-text" @click="toggleView">Wachtwoord vergeten?</b-button>
                            <b-button type="is-dark" @click="submitLogin">Inloggen</b-button>
                        </div>
                    </slide-up-down>

                    <slide-up-down :active="view == 'password'" :duration="500">
                        <div class="login-image">
                            <img src="/images/undraw_forgot_password_gi2d.svg">
                        </div>

                        <h4 class="text-center">Wachtwoord vergeten</h4>


                        <slide-up-down :active="!passwordsuccess" :duration="500">
                            <slide-up-down :active="!!passworderror" :duration="500">
                                <b-notification type="is-danger" aria-close-label="Sluiten" role="alert">{{ passworderror != false ? passworderror : '' }}</b-notification>
                            </slide-up-down>

                            <b-field label="E-mailadres">
                                <b-input v-model="loginData.email" type="email" placeholder="mijn@emailadres.nl" @keyup.native.enter="submitPasswordForgotten"></b-input>
                            </b-field>

                            <div class="button-wrap">
                                <b-button type="is-text" @click="toggleView">Terug naar inloggen</b-button>
                                <b-button type="is-dark" @click="submitPasswordForgotten">Verstuur nieuw wachtwoord</b-button>
                            </div>
                        </slide-up-down>
                        <slide-up-down :active="passwordsuccess" :duration="500">
                            <p>Er is een e-mail gestuurd naar {{ loginData.email }} voor je nieuwe wachtwoord!</p>

                            <div class="button-wrap text-center">
                                <b-button type="is-black" @click="toggleView">Terug naar inloggen</b-button>
                            </div>
                        </slide-up-down>
                    </slide-up-down>
                </div>
            </form>

            <p class="copyright">© Copyright {{ moment().format('Y') }} - PlanitEasy.nl - Alle rechten voorbehouden.</p>
        </div>
    </div>
</template>

<script>
export default {
    name: 'LoginBox',
    props: {
        loading: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    data(){
        return {
            view: 'login',
            loginData: {
                email: '',
                password: ''
            },
            loginerror: false,
            timedout: false,

            passworderror: false,
            passwordsuccess: false,
            pitDisabled: false
        }
    },

    mounted () {
        if(this.pitDisabled) return false;

        const authtokenElement = document.getElementById('authtoken')
        if(authtokenElement && authtokenElement.value){
            this.$emit('setLoading', true)

            this.setToken(authtokenElement.value).then(() => {
                this.loginerror = false
                authtokenElement.remove()
                this.$emit('setLoading', false)
                this.$emit('setLoggedIn', true)
            }).catch((error) => {
                console.error('[❌] Error while logging in:', error)
                authtokenElement.remove()

                if (_.has(error, 'response.data.error')) {
                    this.loginerror = error.response.data.error
                }

                this.$emit('setLoading', false)
            })
        }

        if(_.has(this.$route, 'query.timedout')){
            this.timedout = true
        }
    },

    methods: {
        submitLogin(){
            this.$emit('setLoading', true)
            this.loginerror = false
            this.timedout = false

            axios.post('/api/login', this.loginData)
                .then((response) => {
                    this.$emit('setLoggedIn', true)
                    this.setToken(response.data.token)

                    this.loginData.email = ''
                    this.loginData.password = ''

                    this.$emit('setLoading', false)
                }).catch((error) => {
                    console.error('[❌] Error while logging in:', error)

                    if(error){
                        this.loginerror = error.response.data.error
                        this.loginData.password = ''
                    }

                    this.$emit('setLoading', false)
                })
        },

        submitPasswordForgotten(){
            this.$emit('setLoading', true)
            this.passworderror = false

            axios.post('/api/wachtwoord-vergeten', {'email': this.loginData.email})
            .then((response) => {
                this.passwordsuccess = true
            }).catch((error) => {
                this.passworderror = error.response.data.error
                this.loginData.email = ''
            }).then(() => {
                this.$emit('setLoading', false)
            })
        },

        setToken(token){
            return new Promise((resolve, reject) => {
                this.$store.dispatch('setToken', token).then(() => {
                    this.$store.dispatch('loadApp').then((response) => {
                        if(response == 'loaded'){
                            resolve()
                        }
                    }).catch((error) => {
                        reject(error)
                    })
                }).catch((error) => {
                    reject(error)
                })
            })
        },

        toggleView(){
            this.view = this.view == 'login' ? 'password' : 'login'
            this.passwordsuccess = false
        }
    }

}
</script>